import UserProfileNavbar from '../common/UserProfileNavbar';

const UserProfileLayout = ({ children }) => {
  return (
    <div className="content">
      <div className="page-with-sidebar page-personal">
        <UserProfileNavbar />
        {children}
      </div>
    </div>
  );
};

export default UserProfileLayout;
